import { action } from '@ember/object';
import { debounceTask } from 'ember-lifeline';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class DropdownsSearchableComponent extends Component {
  timer = null;
  @tracked text = null;

  get onSearch() {
    return this.args?.onSearch ?? function () {};
  }

  @action
  handleTextChange(e) {
    this.text = e.target.value;
    debounceTask(this, 'onSearch', e.target.value, 500);
  }
}
